import { useState } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import { BsExclamationCircleFill, BsCircleFill } from "react-icons/bs";
import { formatRelative } from "date-fns/formatRelative";

type ErrorListGroupItemProps = {
  severity: string,
  code: string,
  containerName: string,
  timestamp: string,
  description: string,
  darkMode: boolean
}

export default function ErrorListGroupItem({severity, code, containerName, timestamp, description, darkMode}: ErrorListGroupItemProps) {
  const [ newError, setNewError ] = useState(true);

  return (
    <ListGroup.Item action className="py-4" style={{backgroundColor: darkMode ? "#212529" : "", color: darkMode ? "white" : "inherit", borderBottom: darkMode ? "1px solid white" : "1px solid lightgrey"}} onMouseEnter={() => setNewError(false)}>
      <span className="d-flex align-items-center mb-1">
        <BsExclamationCircleFill 
          size={20} 
          color={
            severity === "ERROR" 
              ? "red" 
              : severity === "WARNING"
                ? "gold"
                : "lightgrey"
          }
        />
        <p className="mb-0 ps-2"><b>{code}</b> - {containerName}</p>
        {newError && <BsCircleFill className="ms-2 pt-1" color="#6faff7" size={15} />}
      </span>
      <p className={`mb-2 ${darkMode ? "text-light" : "text-secondary"}`} style={{fontSize: "0.8em"}}>{formatRelative(new Date(timestamp), (new Date(Date.now())))}</p>
      <p className={`mb-0 error-description ${darkMode ? "text-light" : "text-secondary"}`}>{description}</p>
    </ListGroup.Item>
  );
}